
class YandexMap {

    constructor() {
        this.yandex_key = '799194d3-816b-423f-9a53-b6070b4f2954'
        this.timeout = 0
        this.element = null
        this.map = null
        this.is_init = false
        this.placemark_hash = {}
    }

    _init() {
        this.is_init = true
        return new Promise((resolve, reject)=>{
            let script = document.createElement('script')
            let src = `https://api-maps.yandex.ru/2.1?apikey=${this.yandex_key}&load=package.full&lang=ru_RU`
            script.setAttribute('src', src)
            script.dataset.script = 'ymaps'
            window.ymaps_script = script

            script.addEventListener('load', ()=>{
                ymaps.ready(()=>{
                    resolve(ymaps)
                })
            })

            setTimeout(() => {
                document.body.append(script)
            }, this.timeout);
        })
    }

    _getYmaps() {
        if ( typeof ymaps === 'undefined' ) {
            if (window.ymaps_script) {
                this.is_init = true
                return new Promise((resolve, reject)=>{
                    ymaps_script.addEventListener('load', ()=>{
                        ymaps.ready(()=>{
                            resolve(ymaps)
                        })
                    })
                })
            } else {
                return this._init()
            }

        } else {
            return new Promise((resolve, reject)=>{
                resolve(ymaps)
            })
        }
    }

    addMap( element, state, options={} ) {
        this.element = element
        return this._getYmaps()
        .then((ymaps)=>{
            this.map = new ymaps.Map(element, state, options)
            element.dispatchEvent(new CustomEvent('ymapsReady', {
                bubbles:true,
                cancelable:true,
                ymaps
            }))
            return this.map
        })
    }

    getMap() {
        return new Promise((resolve, reject) => {
            if ( this.map ) {
                resolve(this.map)
            } else {
                if ( this.is_init && this.element ) {
                    this.element.addEventListener('ymapsReady', (e)=>{
                        resolve(this.map)
                    })

                } else {
                    console.error('!!!')
                    reject('error')
                }
            }
        })
    }

    initSearch(element, options={}) {
        return this.getMap()
            .then(() => {
                if ( !element ) {
                    console.error('search field not found')
                    return false
                }
                
                let suggest = new ymaps.SuggestView(element, options);
                suggest.events.add('select', (e)=>{
                    let item = e.get('item')
                    if ( !item ) return false
                    let address = item.value.trim()
                    this.getCoordByAddress( address )
                        .then((coord)=>{
                            let placemark_raw = {
                                geometry: coord
                            }

                            this.addPlacemarks([placemark_raw], true)
                                .then(()=>{
                                    this.map.setCenter(coord)
                                    this.map.setZoom(17)
                                })
                        })
                })

                return suggest
            })
    }

    getCoordByAddress( address ) {
        return this.getMap()
            .then(()=>{
                return ymaps.geocode(address, {results:1})
            })
            .then((res) => {
                let MyGeoObj = res.geoObjects.get(0)
                let coord = MyGeoObj.geometry.getCoordinates()
                return coord
            })
    }

    getAddressByCoord( coord ) {
        return this.getMap()
            .then(() => {
                return ymaps.geocode(coord)
            })
            .then((res) => {
                let firstGeoObject = res.geoObjects.get(0);
                let house_num = firstGeoObject.getPremiseNumber()
                if (!house_num) return ''
                // let address = firstGeoObject.getAddressLine()
                let street = firstGeoObject.getThoroughfare()
                let city = firstGeoObject.getLocalities().length ? firstGeoObject.getLocalities() : firstGeoObject.getAdministrativeAreas()
                let address = `${street}, ${house_num}, ${city}`
                return address
            })
    }

    addPlacemarks( placemark_raw_list, clear=false ) {
        return this.getMap()
            .then(() => {
                if ( clear ) {
                    this.map.geoObjects.removeAll()
                }
                let geoobjects = []
                let index = 0
                for (const placemark_raw of placemark_raw_list) {
                    if ( !placemark_raw.properties ) placemark_raw.properties = {}
                    if ( !placemark_raw.options ) placemark_raw.options = {}
                    if ( !placemark_raw.events ) placemark_raw.events = {}

                    if ( ![undefined, null].includes(placemark_raw.properties.id) ) {
                        this.placemark_hash[placemark_raw.properties.id] = index
                    }

                    let placemark = new ymaps.Placemark(placemark_raw.geometry, placemark_raw.properties, placemark_raw.options)
                    if ( placemark_raw.events && Object.keys(placemark_raw.events).length ) {
                        for (const [event, callback] of Object.entries(placemark_raw.events)) {
                            placemark.events.add(event, (e)=>callback(e))
                        }
                    }

                    geoobjects.push( placemark )
                    index++
                }

                let cluster = new ymaps.Clusterer
                cluster.add(geoobjects)
                this.map.geoObjects.add(cluster)

                return this
            })
            
    }

    getPlacemarks() {
        return this.getMap()
            .then(() => {
                let cluster = this.map.geoObjects.get( 0 )
                if ( cluster ) {
                    return cluster.getGeoObjects()
                } else {
                    return []
                }
            })
    }

    centerToPlacemark( placemark_id ) {
        return this.getMap()
            .then(() => {
                if ( this.placemark_hash[placemark_id] === undefined ) {
                    console.error('geoobject id not found')
                    return this
                }
                let index = this.placemark_hash[placemark_id]
                let cluster = this.map.geoObjects.get( 0 )
                let find = null
                if ( cluster ) {
                    find = cluster.getGeoObjects().find(placemark => placemark.properties.get('id') === placemark_id)
                }
                if (!find ) {
                    console.error('geoobject not found')
                    return this
                }
                window.placemark = find
                let coord = find.geometry.getCoordinates()
                this.map.setCenter(coord)

                return this
            })
    }

    zoom( zoom ) {
        return this.getMap()
            .then(() => {
                this.map.setZoom(zoom)

                return this
            })
    }

    clearMap() {
        return this.getMap()
            .then(() => {
                this.map.geoObjects.removeAll()

                return this
            })
    }
}

export default YandexMap